import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Abonnés',
  fields: {
    name: 'Nom :',
    email: 'E-mail :',
    phone_number: 'Téléphone :',
    subscribed: 'Abonné :',
    birthday: 'Date de naissance :',
    location: 'Localisation :',
    followed: 'Suivi :',
    lifetime_spent: 'Total dépensé :',
    total_orders: 'Commandes totales :',
    google_review: 'Avis Google :',
    loyalty_lifetime: 'Fidélité totale :',
    loyalty_points: "Fidélité aujourd'hui :",
  },
  labels: {
    yes: 'Oui',
    no: 'Non',
    followed_since_date: 'Depuis {{date}}',
  },
  buttons: {
    edit: 'Modifier',
    request_data_deletion: 'Demander la suppression des données',
  },
  toasts: {
    failed_to_load_data: 'Impossible de charger les données',
  },
  tabs: {
    recent_orders: {
      title: 'Commandes récentes',
      columns: {
        order_id: 'Id',
        items: 'Articles',
        total: 'Montant total',
        paid_on: 'Payé le',
        payment_method: 'Mode de paiement',
      },
      labels: {
        no_orders: 'Aucune commande',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Carte',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Prélèvement bancaire',
        [PaymentMethods.CASH]: 'Espèces',
        [PaymentMethods.BACS_DEBIT]: 'Prélèvement bancaire',
      },
    },
    messages: {
      title: 'Messages',
      columns: {
        template: 'Modèle',
        status: 'Statut',
        opened: 'Ouvert',
        clicked: 'Cliqué',
        spam_complaint: 'Signalement spam',
        unsubscribed: 'Désabonné',
        sent_at: 'Envoyé le',
      },
      labels: {
        yes: 'Oui',
        no: 'Non',
        not_detected: 'Non détecté',
        opened_at: 'Ouvert le {{date}}',
        clicked_at: 'Cliqué le {{date}}',
        complained_at: 'Signalé le {{date}}',
        unsubscribed_at: 'Désabonné le {{date}}',
        no_messages: "Aucun message pour l'instant",
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Envoyé',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Remis',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Échoué',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Impossible de charger les données',
      },
    },
    balance_history: {
      title: 'Historique du solde',
      columns: {
        created_at: 'Date',
        source: 'Source',
        value: 'Points',
        points_expire_at: 'Expire le',
      },
      labels: {
        source: {
          welcome_bonus: 'Bonus de bienvenue',
          google_review_reward: 'Récompense avis Google',
          reward_loyalty_program_conversion: 'Récompense conversion programme fidélité',
          cashback: 'Cashback',
          refund: 'Remboursement',
          cashback_usage: 'Utilisation du cashback',
          cashback_usage_refund: "Remboursement d'utilisation cashback",
          expired_points_void: 'Annulation points expirés',
          mobile_app_signup_bonus: "Bonus d'inscription app mobile",
        },
        no_operations: "Aucune opération pour l'instant",
      },
    },
  },
};
